/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCompass: {
  name: 'compass';
  data: string;
} = {
  name: 'compass',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm2.474 5.658a.5.5 0 0 0-.632-.632l-3 1a.5.5 0 0 0-.316.316l-1 3a.5.5 0 0 0 .632.632l3-1a.5.5 0 0 0 .316-.316l1-3ZM6.791 9.21l.604-1.814 1.814-.604-.604 1.814-1.814.604Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
